import React, { Fragment } from "react";
import { isNullOrUndefined } from "../../../../common/utils";
import { InputFields } from "../../inputFields/userGroupInputFields";
import {
  differenceBetweenTwoKeyConditions,
  KeyConditionInputModificationType,
} from "../../utils/differenceBetweenTwoKeyConditions";
import { SimpleConditionStringRender } from "../simpleConditionStringRender";
import "./index.css";

function KeyConditionDifference({ mainKeyCondition, editedKeyCondition }) {
  let keyConditionDifference;
  if (!isNullOrUndefined(mainKeyCondition) && !isNullOrUndefined(editedKeyCondition)) {
    keyConditionDifference = differenceBetweenTwoKeyConditions(
      mainKeyCondition,
      editedKeyCondition,
    );
  }

  function columnTitleRender(title) {
    return <div className="key-condition-difference-table-heading">{title}</div>;
  }

  const dataSource = [];

  let previousValueLastSeenIndex;
  let count = 0;
  for (let attribute in keyConditionDifference) {
    if (!isNullOrUndefined(keyConditionDifference[attribute].previousValue)) {
      previousValueLastSeenIndex = count;
    }
    dataSource.push({
      ...keyConditionDifference[attribute],
      attribute: attribute,
      label: InputFields[attribute].attributeLabel,
      isAndRequiredForExistingKeyCondition: true,
      isAndRequiredForEditedKeyCondition: true,
    });
    count += 1;
  }

  dataSource[previousValueLastSeenIndex].isAndRequiredForExistingKeyCondition = false;
  dataSource[dataSource.length - 1].isAndRequiredForEditedKeyCondition = false;

  function renderCondition(label, value, modifiedClassName) {
    return (
      <>
        {!isNullOrUndefined(value) ? (
          <div className={modifiedClassName + " key-condition-difference-cell"}>
            <SimpleConditionStringRender
              label={label}
              value={value}
            />
          </div>
        ) : (
          <div/>
        )}
      </>
    );
  }

  function displayExistingKeyCondition(record) {
    const modifiedClassName =
      record.changeType === KeyConditionInputModificationType.deleted
        ? "edited-key-condition-deleted-difference"
        : null;
    return renderCondition(record.label, record.previousValue, modifiedClassName);
  }

  function displayEditedKeyCondition(record) {
    const modifiedClassName =
      record.changeType === KeyConditionInputModificationType.modified
        ? "edited-key-condition-changed-difference"
        : record.changeType === KeyConditionInputModificationType.added
        ? "edited-key-condition-added-difference"
        : null;
    return renderCondition(record.label, record.newValue, modifiedClassName);
  }

  function renderAndOperator(isAndRequired, value) {
    return (
      <>
        {isAndRequired === true && !isNullOrUndefined(value) ? (
          <div className="key-condition-difference-and-operator">AND</div>
        ) : (
          <div/>
        )}
      </>
    );
  }

  return (
    <div className="key-condition-difference-container">
      {columnTitleRender("Existing key condition")}
      {columnTitleRender("Updated key condition")}
      {dataSource.map((eachDifference) => {
        return (
          <Fragment key={eachDifference.attribute}>
            {displayExistingKeyCondition(eachDifference)}
            {displayEditedKeyCondition(eachDifference)}
            {renderAndOperator(
              eachDifference.isAndRequiredForExistingKeyCondition,
              eachDifference.previousValue,
            )}
            {renderAndOperator(
              eachDifference.isAndRequiredForEditedKeyCondition,
              eachDifference.newValue,
            )}
          </Fragment>
        );
      })}
    </div>
  );
}

export default KeyConditionDifference;
